export var NotificationLevel;
(function (NotificationLevel) {
    NotificationLevel["Error"] = "error";
    NotificationLevel["Warning"] = "warning";
    NotificationLevel["Success"] = "success";
})(NotificationLevel || (NotificationLevel = {}));
